
import { Product } from "@/types/product";

export const controlProcessorProducts: Product[] = [
  {
    id: "rxc-1-g2",
    groupId: "reax-controllers",
    name: "RXC-1-G2",
    description: "The RXC-1-G2 is a compact yet powerful ReAX control processor designed for small to medium-sized AV systems. This second-generation processor features enhanced connectivity options including RS-232/485, dual IR ports, relay controls, and digital I/O, all in a space-saving 1U quarter-width form factor.\n\nPowered by PoE for simplified installation, the RXC-1-G2 delivers reliable control capabilities through the ReAX Core platform. It supports JavaScript programming through the intuitive Core Studio development environment, making it easy to create sophisticated control solutions. The processor's real-time monitoring and web-based configuration interface provide seamless system management and maintenance.\n\nThe RXC-1-G2 is perfect for conference rooms, classrooms, and other spaces requiring precise AV control. Its compact size and versatile connectivity make it an ideal choice for installations where space is at a premium but professional-grade control capabilities are essential.",
    features: [
      "Compact 1U Quarter-width Design",
      "ReAX Core JavaScript Engine",
      "Core Studio Compatible",
      "RS-232/485 Port",
      "Dual IR/Serial Ports",
      "2 Relay Controls",
      "2 Digital I/O Ports",
      "PoE Powered",
      "Web Configuration Interface",
      "Real-time System Monitoring",
      "JavaScript Programming",
      "USB-C Port",
      "Status Display",
      "Menu Navigation Buttons",
      "Front Panel Status LEDs"
    ],
    specifications: [
      "Processor: ARM Cortex A53",
      "Memory: 512MB RAM",
      "Storage: 4GB eMMC Flash",
      "Network: 10/100 Ethernet with PoE",
      "Serial: 1x RS-232/485",
      "IR: 2x IR/Serial Ports",
      "Relay: 2x Relay Controls",
      "I/O: 2x Digital I/O",
      "USB: 1x USB-C",
      "Display: Front Panel Status Display",
      "Controls: Menu and Select Buttons",
      "Power: IEEE 802.3af PoE",
      "Mounting: Desktop or Rack Mount (kit available)",
      "Dimensions: 4.25\" x 1.75\" x 6\"",
      "Weight: 1.0 lbs",
      "Operating Temperature: 0°C to 40°C",
      "Operating Humidity: 20% to 90% non-condensing",
      "Certification: CE, FCC, RoHS"
    ],
    images: [
      "/lovable-uploads/eaee63bd-90a8-42d1-979f-0ff061b5be4d.png",
      "/lovable-uploads/b25ee53c-fb37-4b93-bf96-f7df25e92e0c.png"
    ],
    image: "/lovable-uploads/eaee63bd-90a8-42d1-979f-0ff061b5be4d.png",
    slug: "rxc-1-g2"
  },
  {
    id: "rxc-3-g2",
    groupId: "reax-controllers",
    name: "RXC-3-G2",
    description: "The RXC-3-G2 is a powerful mid-range ReAX control processor that delivers enhanced connectivity and control capabilities for sophisticated AV systems. This second-generation processor features dual LAN ports with PoE (Power over Ethernet) support, three RS-232/485 ports, three IR ports, relay controls, and digital I/O, all in a sleek 1U half-width form factor.\n\nPowered by an advanced ARM Cortex processor and equipped with 1GB of RAM, the RXC-3-G2 provides robust processing power for demanding control applications. It runs on the ReAX Core platform, supporting JavaScript programming through the intuitive Core Studio development environment. This makes it easy to create sophisticated control solutions for complex AV systems.\n\nThe processor's comprehensive connectivity options, including dual network interfaces and multiple control ports, make it perfect for medium to large installations requiring reliable, high-performance control capabilities. Its web-based configuration interface and real-time monitoring features ensure seamless system management and maintenance.",
    features: [
      "Dual LAN Ports with PoE",
      "Three RS-232/485 Ports",
      "Three IR/Serial Ports",
      "Relay Controls",
      "Digital I/O",
      "ReAX Core JavaScript Engine",
      "Core Studio Compatible",
      "1GB RAM",
      "8GB Storage",
      "Web Configuration Interface",
      "Real-time System Monitoring",
      "Status Display",
      "Menu Navigation Controls",
      "Front Panel Status LEDs",
      "USB-C Port",
      "1U Half-width Design"
    ],
    specifications: [
      "Processor: ARM Cortex A53",
      "Memory: 1GB RAM",
      "Storage: 8GB eMMC Flash",
      "Network: 2x 10/100/1000 Ethernet (1x PoE)",
      "Serial: 3x RS-232/485",
      "IR: 3x IR/Serial Ports",
      "Relay: 2x Relay Controls",
      "I/O: 2x Digital I/O",
      "USB: 1x USB-C",
      "Display: Front Panel Status Display",
      "Controls: Menu and Select Buttons",
      "Power: IEEE 802.3af PoE or 12V DC",
      "Mounting: Desktop or Rack Mount (kit available)",
      "Dimensions: 8.5\" x 1.75\" x 6\"",
      "Weight: 1.8 lbs",
      "Operating Temperature: 0°C to 40°C",
      "Operating Humidity: 20% to 90% non-condensing",
      "Certification: CE, FCC, RoHS"
    ],
    images: [
      "/lovable-uploads/627ea85d-0d29-4555-bfbc-e539fec6e553.png",
      "/lovable-uploads/27120aa5-9d0b-4cbe-9d07-e317a1b673cb.png"
    ],
    image: "/lovable-uploads/627ea85d-0d29-4555-bfbc-e539fec6e553.png",
    slug: "rxc-3-g2"
  },
  {
    id: "rxc-4-g2",
    groupId: "reax-controllers",
    name: "RXC-4-G2",
    description: "The RXC-4-G2 is Aurora's flagship ReAX control processor, designed for large-scale and enterprise-level AV systems that demand extensive connectivity and superior processing power. This full-width 1U rack-mountable processor features a high-performance dual-core ARM processor with 2GB of RAM and 16GB of storage, making it capable of handling the most complex control environments with ease.\n\nWith an extensive array of connectivity options including dual Gigabit LAN ports with PoE+, six RS-232/485 ports, four IR/serial ports, four relay controls, and four digital I/O connections, the RXC-4-G2 offers unparalleled integration capabilities for sophisticated multi-room or campus-wide AV control systems.\n\nPowered by the ReAX Core Engine, the RXC-4-G2 supports advanced JavaScript programming through the intuitive Core Studio development environment. This allows integrators to create complex, customized control solutions with ease. The processor features a comprehensive web-based configuration interface and real-time system monitoring, enabling seamless integration with enterprise management systems.\n\nThe front panel includes a detailed status display and intuitive menu navigation, allowing for quick diagnostics and local configuration. Perfect for corporate headquarters, university auditoriums, performance venues, and other large-scale installations, the RXC-4-G2 delivers reliable, powerful, and flexible control for the most demanding AV environments.",
    features: [
      "Full-width 1U Rack-mountable Design",
      "Dual-core ARM Processor",
      "2GB RAM and 16GB Storage",
      "Dual Gigabit LAN with PoE+",
      "Six RS-232/485 Ports",
      "Four IR/Serial Ports",
      "Four Relay Controls",
      "Four Digital I/O Connections",
      "ReAX Core JavaScript Engine",
      "Core Studio Compatible",
      "Enterprise-level System Integration",
      "USB-C Port",
      "Status Display with Menu Navigation",
      "Front Panel Status LEDs",
      "Advanced Scheduling Capabilities",
      "Comprehensive Web Configuration",
      "Real-time System Monitoring",
      "Multi-room Control Support"
    ],
    specifications: [
      "Processor: Dual-core ARM Cortex A53",
      "Memory: 2GB RAM",
      "Storage: 16GB eMMC Flash",
      "Network: 2x 10/100/1000 Ethernet (1x PoE+)",
      "Serial: 6x RS-232/485",
      "IR: 4x IR/Serial Ports",
      "Relay: 4x Relay Controls",
      "I/O: 4x Digital I/O",
      "USB: 1x USB-C",
      "Display: Front Panel Status Display",
      "Controls: Menu and Select Buttons",
      "Power: IEEE 802.3at PoE+ or 12V DC",
      "Mounting: 1U Rack Mount",
      "Dimensions: 17\" x 1.75\" x 6\"",
      "Weight: 3.5 lbs",
      "Operating Temperature: 0°C to 40°C",
      "Operating Humidity: 10% to 90% non-condensing",
      "Certification: CE, FCC, RoHS"
    ],
    images: [
      "/lovable-uploads/5f63c281-54ab-4ac4-8ea2-e07de98cf328.png",
      "/lovable-uploads/b97879ea-0d95-41f5-bc96-87f8a8c3b3d6.png"
    ],
    image: "/lovable-uploads/5f63c281-54ab-4ac4-8ea2-e07de98cf328.png",
    slug: "rxc-4-g2"
  }
];
